const initState = {
  searchThreadList: {
    list: null,
    keyword: '', // 關鍵字
    sort: 'desc', // 排序
    pageSize: 20, // 一页几笔
    total: 0, // 总笔数
    page: 1, // 第几页
    pages: 1, // 总页数
  },
  searchUserList: {
    list: null,
    keyword: '', // 關鍵字
    pageSize: 20, // 一页几笔
    total: 0, // 总笔数
    page: 1, // 第几页
    pages: 1, // 总页数
  },
}

const state = Object.assign({}, initState)

export {
  initState,
  state
}